import * as ACTION_TYPES from "./action_types";

export const initialState = {
  isAuthenticated: false,
  profile: null,
  //this flag is only for the first time we arrive at the 
  //application
  authAttempted: false
};

export const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.LOGIN_SUCCESS:
      console.log("Login success")
      return {
        ...state,
        isAuthenticated: true,
        profile: action.payload,
        authAttempted: true
      };
    case ACTION_TYPES.LOGOUT:
      return {
        ...initialState,
        authAttempted: true
      };
    case ACTION_TYPES.LOGIN_FAILURE:
      return {
        ...initialState,
        authAttempted: true
      };
    default:
      return state;
  }
};
